module.exports = __webpack_public_path__ + "img/user1.ce92d18c.png";